<template>
  <!-- An alternative to v-chip-group that handles side-scrolling properly -->
  <div class="relative">
    <div
      ref="scroll"
      class="overflow-auto pa-1 scroll-container"
      style="white-space: nowrap;"
      v-bind:style="{
        'mask-image': `linear-gradient(90deg, #FFF${left ? '0' : 'F'}, #FFFF 80px, #FFFF calc(100% - 80px), #FFF${right ? '0' : 'F'})`
      }"
      @scroll="updateScroll"
    >
      <slot></slot>
    </div>
    <div v-if="!IS_TOUCH" class="absolute-fill d-flex align-center pa-1" style="pointer-events: none;">
      <v-btn
        v-if="left"
        style="pointer-events: auto;"
        fab small
        @click="$refs.scroll.scrollTo({ left: $refs.scroll.scrollLeft - $refs.scroll.offsetWidth, behavior: 'smooth' })"
      >
        <v-icon v-html="mdiChevronLeft" />
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="right"
        style="pointer-events: auto;"
        fab small
        @click="$refs.scroll.scrollTo({ left: $refs.scroll.scrollLeft + $refs.scroll.offsetWidth, behavior: 'smooth' })"
      >
        <v-icon v-html="mdiChevronRight" />
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.scroll-container > * {
  flex: 0 0 auto;
}
</style>

<script>
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';

export default {
  name: 'side-scroller',

  props: [ 'mode', 'order', 'isCardOwner', 'isVerifiedRecipient', 'width' ],

  data() {
    return {
      left: false,
      right: false
    }
  },

  created() {
    Object.assign(this, { mdiChevronLeft, mdiChevronRight });
  },

  mounted() {
    this.updateScroll();
  },

  methods: {
    updateScroll() {
      const { scrollLeft, offsetWidth, scrollWidth } = this.$refs.scroll;
      this.left = !!scrollLeft;
      this.right = scrollLeft + offsetWidth < scrollWidth - 1;
    }
  }
}
</script>
